import { HttpStatusEnum } from '@core/api/http-status.enum';
import { HttpResponse } from '@core/api/http-response.interface';

export class ApiHelper {
    static resolveError(resolve: (data: any) => any, message: string): HttpResponse<null> {
        return resolve({
            isLoading: false,
            status: HttpStatusEnum.ERROR,
            message,
            data: null,
        });
    }

    static resolveUndefined(resolve: (data: any) => any, message: string): HttpResponse<null> {
        return resolve({
            isLoading: false,
            status: HttpStatusEnum.UNDEFINED,
            message,
            data: null,
        });
    }

    static resolveSuccess(resolve: (data: any) => any, message: string): HttpResponse<null> {
        return resolve({
            isLoading: false,
            status: HttpStatusEnum.SUCCESS,
            message,
            data: null,
        });
    }
}
